import { DEFAULT_DESKTOP_LAYOUT, DEFAULT_LANDSCAPE_TABLET_LAYOUT, DEFAULT_PHONE_LAYOUT, DEFAULT_TABLET_LAYOUT, } from "./constants";
/**
 * Gets the current layout based on the app size and layout configuration.
 *
 * @return The current layout type
 */
export function getLayoutType(_a) {
    var appSize = _a.appSize, _b = _a.phoneLayout, phoneLayout = _b === void 0 ? DEFAULT_PHONE_LAYOUT : _b, _c = _a.tabletLayout, tabletLayout = _c === void 0 ? DEFAULT_TABLET_LAYOUT : _c, _d = _a.landscapeTabletLayout, landscapeTabletLayout = _d === void 0 ? DEFAULT_LANDSCAPE_TABLET_LAYOUT : _d, _e = _a.desktopLayout, desktopLayout = _e === void 0 ? DEFAULT_DESKTOP_LAYOUT : _e, _f = _a.largeDesktopLayout, largeDesktopLayout = _f === void 0 ? desktopLayout : _f;
    var isPhone = appSize.isPhone, isTablet = appSize.isTablet, isLargeDesktop = appSize.isLargeDesktop, isLandscape = appSize.isLandscape;
    if (isPhone) {
        return phoneLayout;
    }
    if (isTablet) {
        return isLandscape ? landscapeTabletLayout : tabletLayout;
    }
    if (isLargeDesktop) {
        return largeDesktopLayout;
    }
    return desktopLayout;
}
/**
 * Checks if the current `layout` is one of the temporary types
 *
 * @param layout The layout to check against
 * @return true if the current layout has a temporary navigation.
 */
export function isTemporaryLayout(layout) {
    return layout === "temporary" || layout === "temporary-mini";
}
/**
 * Checks if the current `layout` is one of the toggleable types
 *
 * @param layout The layout to check against
 * @return true if the current layout is toggleable.
 */
export function isToggleableLayout(layout) {
    return layout === "toggleable" || layout === "toggleable-mini";
}
/**
 * Checks if the current `layout` is `"clipped"`, `"floating"`, or `"full-height"`.
 *
 * @param layout The layout to check against
 * @return true if the current layout is persistent.
 */
export function isPersistentLayout(layout) {
    return (layout === "clipped" || layout === "floating" || layout === "full-height");
}
/**
 * Checks if the current `layout` is the `"full-height"` variant.
 *
 * @param layout The layout to check against
 * @return true if the current layout is the full height variant.
 */
export function isFullHeightLayout(layout) {
    return layout === "full-height";
}
//# sourceMappingURL=utils.js.map